import {
  SET_SHARED_SETTINGS,
} from './constants';

export const setSharedSettings = (sharedSettings) => ({
  type: SET_SHARED_SETTINGS,
  sharedSettings
});